import { isNumber } from "lodash";

export const isMultiple = (obj: number | null | undefined): obj is number => isNumber(obj) && obj > 1;
